import { ChangeDetectionStrategy, Component, input, ViewEncapsulation } from '@angular/core';
import { ColumnConfigEx, ColumnDefinitionEx } from "../../../../@core/types/column-config-types-extended";
import { applySearchRule } from '../../../../@core/utils/search-input-helper';
import { AddressGroup, DiscountGroupVendorGroupRelation, DiscountGroupVendorGroupRelationSearchInput, Operator } from "../../../../generated/generated-types";
import { BaseListWrapperComponent } from '../../../../shared/components/base-list-wrapper/base-list-wrapper.component';
import { NewBaseListComponent } from "../../../../shared/components/new-base-list-component/new-base-list-component";
import { AddressGroupDropdownComponent } from "../../../crm/controls/address-group-dropdown/address-group-dropdown.component";
import { DiscountGroupVendorGroupRelationService } from "../../services/discount-group-vendor-group-relation.service";

@Component({
  selector: 'app-discount-group-vendor-group-relation-widget',
  template: `<app-base-list-wrapper [baseListComponent]="this" />`,
  encapsulation: ViewEncapsulation.Emulated,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    BaseListWrapperComponent,
  ]
})
export class DiscountGroupVendorGroupRelationWidgetComponent extends NewBaseListComponent<DiscountGroupVendorGroupRelation> {

  discountGroupId = input<string>();

  constructor(
    discountGroupVendorGroupRelationService: DiscountGroupVendorGroupRelationService,
  ) {
    super("DiscountGroupVendorGroupRelation", discountGroupVendorGroupRelationService);

    this.addInDetail = false;
    this.noCopy = true;
    this.noBaseEdit = true;
    this.inlineEditMode = true;
  }

  override getSearchInputForQuery(): DiscountGroupVendorGroupRelationSearchInput {
    let si: DiscountGroupVendorGroupRelationSearchInput = super.getSearchInputForQuery();

    applySearchRule(si, {
      field: "discountGroupId",
      operator: Operator.equal,
      value: this.discountGroupId()
    });

    return si;
  }

  protected override setColumnConfig(colConfig: ColumnConfigEx): void {
    let col: ColumnDefinitionEx = colConfig.columns.find(x => x.field === 'vendorGroup.identifier' || (x.prop === "identifier" && x.entityType === 'AddressGroup'));
    if (col) {
      col.getEditComponent = () => AddressGroupDropdownComponent;
      col.editComponentCreated = async (c: AddressGroupDropdownComponent, rowData: any, _colDef: ColumnDefinitionEx) => {
        if (rowData?.vendorGroup)
          c.setModel(rowData.vendorGroup);
        else if (rowData?.vendorGroupId) {
          await c.loadItemByIdAndSetSelected(rowData.vendorGroupId);
          this.cdRef.detectChanges();
        }

        c.value.subscribe(async (x: AddressGroup) => {
          rowData.vendorGroupId = x?.id;
        });
      }
    }

    super.setColumnConfig(colConfig);
  }

  override saveInCRUDService(rowData: DiscountGroupVendorGroupRelation): Promise<DiscountGroupVendorGroupRelation> {
    return super.saveInCRUDService({ ...rowData, discountGroupId: this.discountGroupId() });
  }

}
